import { useEffect } from 'react';
import styled from 'styled-components';

interface CourtInfoProps {
  court: string;
  address: string;
  belong: string;
  lat: number;
  lng: number;
}

interface Props {
  courtInfo: CourtInfoProps;
}

const CourtMap = ({ courtInfo }: Props) => {
  useEffect(() => {
    if (window.kakao && window.kakao.maps) {
      const container = document.getElementById('CourtMap');
      const options = {
        center: new window.kakao.maps.LatLng(courtInfo.lat, courtInfo.lng),
        draggable: false,
        level: 3,
      };
      // 지도 생성
      let map = new window.kakao.maps.Map(container, options);

      // 마커 추가 (옵션)
      var marker = new window.kakao.maps.Marker({
        position: new window.kakao.maps.LatLng(courtInfo.lat, courtInfo.lng),
        map: map,
      });
      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);

      var iwContent = `
  <div style="
    width: 100%;
    padding: 10px;
    font-size: 14px;
    white-space: nowrap;
    border-radius: 10px;
  ">
    ${courtInfo.address}
  </div>`;
      var iwPosition = new window.kakao.maps.LatLng(
        courtInfo.lat,
        courtInfo.lng,
      ); //인포윈도우 표시 위치입니다

      // 인포윈도우를 생성합니다
      var infowindow = new window.kakao.maps.InfoWindow({
        position: iwPosition,
        content: iwContent,
      });

      // 마커 위에 인포윈도우를 표시합니다. 두번째 파라미터인 marker를 넣어주지 않으면 지도 위에 표시됩니다
      infowindow.open(map, marker);
    }
  }, []);

  return (
    <Container>
      <MapContainer id="CourtMap"></MapContainer>
    </Container>
  );
};
export default CourtMap;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
`;

const MapContainer = styled.div`
  width: 462px;
  height: 196.5px;
  border: none;
  display: flex;
  outline: none;
`;
